import { createSelector } from '@reduxjs/toolkit';
import { isEmpty } from 'lodash';
import { getRooms } from './rooms';
import { getAllOffers } from '../../utils/offersUtils';
import { getHotelId, getInitialPrice } from '../hotel';
import { getRoomsOperators } from './common';
import { getSearchType } from './view';

export const getOffers = createSelector(
  [getRooms, getHotelId],
  (rooms, hotelId) => (isEmpty(rooms) ? [] : getAllOffers(rooms, hotelId)),
);

export const getAnalyticsOperators = createSelector(
  [getRoomsOperators],
  (operators) => operators.map(({ id }) => id).join('|'),
);

export const selectHotelFiltersAnalyticsData = createSelector(
  [getHotelId, getInitialPrice, getSearchType],
  (hotelId, hotelPrice, searchType) => {
    const url = new URL(window.location.href);
    return {
      id: hotelId,
      min_price: hotelPrice,
      search_type: searchType,
      request_id: url.searchParams.get('request_id'),
    };
  },
);
